import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { useLocalization } from '@ui-framework/index';
import AdvancedListPage from '@product-framework/components/AdvancedListPage';
import { IconLibrary } from '@product-framework/index';

import INSIGHTS_CONFIG_PATH from '../../apiPaths';
import {
  configName,
  configValue,
  configDescription,
  createdDateTime,
  lastModifiedDateTime,
} from './accessorFunctions';
import { listSchema, searchSchema } from '../../schemas';
import validationSchema from './validations';

const config = {
  storeName: 'InsightConfigList',
  apiPathSuffix: INSIGHTS_CONFIG_PATH,
  breadcrumb: {
    id: 'LIST_INSIGHT_CONFIG',
    defaultMessage: 'List Insight Config',
    icon: IconLibrary.System,
  },
  searchHeading: {
    id: 'SEARCH_INSIGHT_CONFIG',
    defaultMessage: 'Search Insight Config',
  },
  listHeading: {
    id: 'INSIGHT_CONFIG',
    defaultMessage: 'Insight Config',
  },
  accessorFunctions: {
    configName,
    configValue,
    configDescription,
    createdDateTime,
    lastModifiedDateTime,
  },
  listSchema,
  searchSchema,
  validationSchema,
};

function InsightConfigList() {
  const { formatMessage } = useLocalization();
  const navigate = useNavigate();
  const extraStackableButtons = [
    {
      label: formatMessage({
        id: 'CREATE_INSIGHT_CONFIG',
        defaultMessage: 'Create Insight Config',
      }),
      Icon: IconLibrary.System,
      variant: 'outlined',
      onClick: () => navigate('/insight-config/create'),
      permissionName: 'CAN_CREATE_EDIT_MAINTENANCE_PAGES',
    },
  ];
  return (
    <AdvancedListPage
      {...config}
      extraStackableButtons={extraStackableButtons}
    />
  );
}

export default observer(InsightConfigList);
